import React from "react"
import {RequestDetailType0,RequestDetailType1} from "../components/tools/RequestDetail"
import Logout from "../components/Logout"

import {useParams} from "react-router-dom"


const RequestDetailContent = () => {
    const {request_id} = useParams()
    const {request_type} = useParams()
    return (
        <>
        <Logout />
        {request_type === '0' && <RequestDetailType0 request_id={request_id}/>}
        {request_type === '1' && <RequestDetailType1 request_id={request_id}/>}
        </>
    )
}
export default RequestDetailContent;

